<template>
  <div>
    <fusioncharts
      v-if="tempGraph"
      width="100%"
      height="470"
      type="zoomline"
      dataFormat="json"
      :dataSource="dataSourceTemp"
    ></fusioncharts>
    <fusioncharts
      v-if="humiGraph"
      width="100%"
      height="470"
      type="zoomline"
      dataFormat="json"
      :dataSource="dataSourceHumi"
    ></fusioncharts>
  </div>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import zoomline from "fusioncharts/fusioncharts.zoomline";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
// FusionCharts.options.license({
//   key: process.env.VUE_APP_FUSION_LICENSE_KEY,
//   creditLabel: false,
// });
Vue.use(VueFusionCharts, FusionCharts, zoomline, FusionTheme);

export default {
  name: "Chart",
  props: {
    singlegroup: Object,
    tempGraph: Boolean,
    humiGraph: Boolean,
    title: String,
  },
  data() {
    return {
      type: "zoomline",
      dataformat: "json",
      chartWidth: "100%",
      dataSourceTemp: "",
      dataSourceHumi: "",
      labels: [],
      temp: [],
      maxTemp: [],
      minTemp: [],
      maxHumi: [],
      minHumi: [],
      humidity: [],
    };
  },
  mounted() {
    this.initialiseGroupChart();
  },
  watch: {
    singlegroup: {
      handler: function() {
        this.initialiseGroupChart();
      },
      deep: true,
    },

  },
  methods: {
    initialiseGroupChart() {
      this.labels = [];
      this.temp = [];
      this.minTemp = [];
      this.maxTemp = [];
      this.humi = [];
      this.minHumi = [];
      this.maxHumi = [];
      for (const element of this.singlegroup.stats) {
        // let year = element._id.year;
        // let month = element._id.month;
        // let day = element._id.day;
        // let hour = element._id.hour;
        // let fulldate = `${year}-${month}-${day} ${hour}`;
        const fulldate2 = moment(element.deviceTimeStamp).format(
          "DD/MM/YY | HH:mm"
        );

        this.labels.push({
          label: fulldate2,
        });
        this.temp.push({
          value: element.temperature,
        });
        this.maxTemp.push({
          value: this.singlegroup.group.maxTemperature,
        });
        this.minTemp.push({
          value: this.singlegroup.group.minTemperature,
        });
        this.maxHumi.push({
          value: this.singlegroup.group.maxHumidity,
        });
        this.minHumi.push({
          value: this.singlegroup.group.minHumidity,
        });
        this.humidity.push({
          value: element.humidity,
        });
      }
      this.dataSourceTemp = {
        chart: {
          caption: this.$t("average_temperature_chart"),
          subcaption: this.$t("sub_cap"),
          yaxisname: this.$t("temp"),
          numbersuffix: "°C",
          xaxisname: this.$t("time"),
          lineThickness: "3",
          theme: "fusion",
          paletteColors: "#213e7a,#DC3030,#F3C963",
          exportEnabled: "1",
          exportFileName: this.title,
        },
        categories: [
          {
            category: this.labels,
          },
        ],
        dataset: [
          {
            seriesName: this.$t("series_name_temp"),
            data: this.temp,
          },
          {
            seriesName: this.$t("max-temp"),
            data: this.maxTemp,
          },
          {
            seriesName: this.$t("min-temp"),
            data: this.minTemp,
          },
        ],
      };
      this.dataSourceHumi = {
        chart: {
          caption: this.$t("average_humidity_chart"),
          subcaption: this.$t("sub_cap"),
          yaxisname: this.$t("humid"),
          numbersuffix: "%",
          xaxisname: this.$t("time"),
          lineThickness: "3",
          theme: "fusion",
          paletteColors: "#213e7a,#DC3030,#F3C963",
          exportEnabled: "1",
          exportFileName: this.title,
        },
        categories: [
          {
            category: this.labels,
          },
        ],
        dataset: [
          {
            seriesName: this.$t("humid"),
            data: this.humidity,
          },
          {
            seriesName: this.$t("max-humid"),
            data: this.maxHumi,
          },
          {
            seriesName: this.$t("min-humid"),
            data: this.minHumi,
          },
        ],
      };
    },
  },
};
</script>

<style scoped></style>
